
import axios      from 'axios';
import RoutesAPI  from './Routes';

let API_URL = '';
if( process.env.REACT_APP_API_URL ) {
  API_URL = process.env.REACT_APP_API_URL;
}

// Requests
const requests = {
  get: (url: string, body: any) => {
    return axios.get(API_URL + url, body);
  }
};

const FAQAPI = {
  getFAQ: (application_id: number) => {
    return requests.get(RoutesAPI.faq());
  },
}

export default FAQAPI;



// WEBPACK FOOTER //
// ./src/api/FAQApi.js